import { CheckCircleOutline } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { Link, useSearch } from 'wouter';
import * as buttonStyles from '~/elements/Buttons/Button.css';
import { useAuth } from '~/utils/hooks/hooks';
import * as styles from './Success.css';

export const Success = () => {
  const { mutate } = useAuth();
  const search = useSearch();
  const sessionId = new URLSearchParams(search).get('session_id');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!sessionId) return;

    const updatePaymentStatus = async () => {
      try {
        const res = await fetch('/api/payment-details', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionId }),
        });

        if (res.ok) {
          const data = await res.json<{ id: string }>();
          void mutate((current) => (current ? { ...current, paid: true, stripe: { id: data.id } } : current), {
            revalidate: false,
          });
        } else {
          setError('Failed to verify payment. Please contact support.');
        }
      } catch {
        setError('Failed to verify payment. Please contact support.');
      }
    };

    void updatePaymentStatus();
  }, [sessionId, mutate]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <CheckCircleOutline className={styles.successIcon} />
        <h1 className={styles.title}>Thank you!</h1>
        <p className={styles.message}>
          Your purchase was successful. You now have access to all Pro features including custom domains, logo
          customization, and more.
        </p>
        {error && <p className={styles.error}>{error}</p>}
        <Link to="/app" className={buttonStyles.primary}>
          Go to your wiki
        </Link>
      </div>
    </div>
  );
};
